import { YupTest } from 'coreOld/types';

const validateRange = (value, min, max) => {
  return value >= min && value <= max;
};

export const testValidRange = (
  label: string,
  min: number,
  max: number,
  required = true
): YupTest => [
  'validRange',
  `${label} must be between ${min} and ${max}`,
  (value) => !required || validateRange(value, min, max),
];

export const testMaxQuantity = (): YupTest => [
  'maxQty',
  `Maximum quantity must be greater than minimum quantity.`,
  (value, testContext: any) => {
    if (Number(value) === 0 || !testContext.originalValue) {
      return true;
    }

    return Number(testContext.parent.minQuantity) <= Number(value);
  },
];
